export default {
    news: '新聞',
    raiders: '攻略',
    world_view: '世界觀',
    ugc: '粉絲UGC',
    hot_news: '熱門資訊',
    recommend: '推薦',
    download: '立即下載',
    empty_data: '沒有其他資料。',
    more: '更多',
    detail: '詳細資訊',
    collapse: '隱藏',
    home_title: '社群',
    top: '置頂',

    team_simulator: '陣容模擬',
    simulator_hero: `點擊"+"添加英雄和神器`,
    active_synergy_title: '羈絆啟動',
    simulator_synergy: '點亮下方羈絆圖示，可啟動羈絆',
    team_hero: '陣容英雄',
    actived_synergy: '已解鎖羈絆',
    checkall_synergy: '全部啟動',
    synergy_effects: '羈絆效果',
    tj_team: '推薦陣容',
    query_link: '查看詳情',
    save_image: '保存圖片',
    share_image: '分享陣容',
    artifact: '神器',
    base_synergy: '女武神羈絆',
    faction_synergy: '陣營羈絆',
    rune_synergy: '符文羈絆',
    hero_detail: '陣容詳情',
    add_hero: '添加你的英雄',
    add_artifact: '添加你的神器',

    relic_synergy_title: '神器羈絆',
    relic_effects: '神器羈絆效果',
    actived_relic_synergy: '已解鎖神器羈絆',
    relic_kind: '類別'
}